import { Toggle, Modal, Button, Loader } from "rsuite";
import { useState, useEffect } from "react";
import { ApiSchemaPatientTask } from "../models/api";
import { ApiPatientTask } from "../core/apis/PatientTask";
import { showToast } from "./toast.component";

export const IsDefaultForDHHSToggle = ({
  task,
}: {
  task: ApiSchemaPatientTask;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [checked, setChecked] = useState(!!task.isDefaultForDHHS);
  useEffect(() => setChecked(!!task.isDefaultForDHHS), [task.isDefaultForDHHS]);

  const handleToggle = async () => {
    setIsLoading(true);
    try {
      await ApiPatientTask.setIsDefaultForDHHS(task, !checked);
      setChecked(!checked);
    } catch (e) {
      showToast("Default change failed!", "error");
    } finally {
      setIsLoading(false);
    }
    handleClose();
  };

  return (
    <>
      {isLoading ? (
        <Loader size="sm" />
      ) : (
        <Toggle
          size="sm"
          onChange={handleOpen}
          disabled={isLoading}
          checked={checked}
        />
      )}
      <Modal open={open} onClose={handleClose}>
        <Modal.Body>
          <p>
            Make <b>{task.displayName || task.name}</b> {checked && "Not"}{" "}
            Default for DHS?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button
            loading={isLoading}
            appearance="primary"
            onClick={handleToggle}
          >
            Ok
          </Button>
          <Button
            onClick={handleClose}
            disabled={isLoading}
            appearance="subtle"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
